import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { formatAbn } from 'src/lib/formatter';
import FieldLabelAndValue from '../FieldLabelAndValue';
import FieldValue from '../FieldValue';
import accountIntentSelectors from '../AccountLinkIntentSummary/selectors';
import { useSelector } from 'react-redux';
import { DateTime } from 'luxon';

const useStyles = makeStyles(() => ({
  selectAccountContainer: {
    width: '100%',
  },
  accountName: {
    fontWeight: 700,
  },
  selectAccountForm: {
    width: '100%',
  },
  selectMenu: {
    width: '23%',
  },
}));

const LinkAccountSummary = () => {
  const classes = useStyles();
  const accountIntent: any = useSelector(accountIntentSelectors.selectAccountIntent);

  return (
    <Grid container className={classes.selectAccountContainer}>
      <Grid item xs={12}>
        <FieldLabelAndValue label='Date account linked' dataTestId='uia-DateLinked'>
          <FieldValue dataTestId='uia-DateLinked'>{DateTime.now().toFormat('dd MMM yyyy')}</FieldValue>
        </FieldLabelAndValue>
        <FieldLabelAndValue label='Business linked to your shift account' dataTestId='uia-MerchantAccount'>
          <FieldValue dataTestId='uia-MerchantAccountName'>{accountIntent.merchantAccountName}</FieldValue>
          <FieldValue dataTestId='uia-MerchantAbn'>{`ABN: ${formatAbn(accountIntent.merchantAbn)}`}</FieldValue>
        </FieldLabelAndValue>
      </Grid>
    </Grid>
  );
};

export default LinkAccountSummary;
